import { useIsFetching } from '@tanstack/react-query'

export function GlobalLoader() {
  const fetching = useIsFetching()
  if (!fetching) return null
  return (
    <div className="fixed top-3 right-3 z-50">
      <div className="h-3 w-3 rounded-full bg-primary animate-pulse" title="Loading" />
    </div>
  )
}

